import React, { Component } from "react";
import { useNavigate } from "react-router-dom";

import "../css/App.css";

class Home extends Component {
  constructor() {
    super();
    this.state = { title: "" };
  }

  handleChange(e) {
    this.state.title = e.target.value;
  }

  handleKeyDown(e) {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      this.props.navigate(`/search?book=${this.state.title}`);
    }
  }

  render() {
    return (
      <div className="app">
        <div className="main-content">
          <div className="search">
            <input
              type="text"
              className="search-box"
              data-testid="search-text-box"
              placeholder="Book title"
              onChange={(e) => this.handleChange(e)}
              onKeyDown={(e) => this.handleKeyDown(e)}
            />
          </div>
        </div>
      </div>
    );
  }
}

function WithNavigate() {
  let navigate = useNavigate();

  return <Home navigate={navigate} />;
}

export default WithNavigate;
